import React from 'react';
import withStyles from '@mui/styles/withStyles';
import { Tooltip } from '@mui/material';

const TooltipWrapper = ({ children, title, classes, placement = 'top', theme, ...props }) => (
    <Tooltip
        arrow
        className="tooltip"
        title={title}
        placement={placement}
        {...props}
        classes={{ tooltip: classes.tooltip }}
        slotProps={{ popper: { sx: arrowGenerator(theme.palette.grey[800]) } }}
    >
        {children}
    </Tooltip>
);

function arrowGenerator(color) {
    return {
        // Target the standard MUI arrow class based on the data-popper-placement attribute
        '& .MuiTooltip-arrow': {
            fontSize: '1rem',
            color: color,
            '&::before': {
                border: '1px solid #FFFFFF',
                backgroundColor: color
            }
        },
        // Adjust offsets depending on placement to match your styling
        '&[data-popper-placement*="bottom"] .MuiTooltip-arrow': {
            top: 0,
            marginTop: '-12px'
        },
        '&[data-popper-placement*="top"] .MuiTooltip-arrow': {
            bottom: 0,
            marginBottom: '-12px'
        },
        '&[data-popper-placement*="right"] .MuiTooltip-arrow': {
            left: 0,
            marginLeft: '-12px'
        },
        '&[data-popper-placement*="left"] .MuiTooltip-arrow': {
            right: 0,
            marginRight: '-12px'
        }
    };
}

const styles = ({ palette }) => ({
    tooltip: {
        margin: '6px!important',
        fontSize: '0.975rem',
        backgroundColor: palette.grey[800],
        border: '1px solid #FFFFFF'
    }
});
export default withStyles(styles, { withTheme: true })(TooltipWrapper);
